<div class="container content mt-5 mt-lg-11 mb-11">
  <div class="row">
    <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
      <ng-container *ngIf="resetForm && !hasToken">
        <div class="card">
          <div class="card-body" *ngIf="!linkSent">
            <div class="row">
              <div class="col">
                <h1 class="card-title">{{ 'Reset password' | translate }}</h1>
              </div>
              <div class="col-auto ml-auto">
                <app-language-dropdown></app-language-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <hr class="mb-4 mb-sm-5 mt-1" />
              </div>
            </div>

            <form (ngSubmit)="onReset()" [formGroup]="resetForm">
              <div class="form-group row mb-5">
                <label class="col-form-label col-sm-4" for="email">{{
                  'E-mail' | translate
                }}</label>
                <div class="col-sm">
                  <input
                    class="form-control"
                    name="email"
                    type="email"
                    novalidate="novalidate"
                    id="email"
                    autofocus=""
                    formControlName="email"
                    [class.is-invalid]="sent && resetForm.get('email').errors"
                  />

                  <div
                    class="invalid-feedback"
                    *ngIf="sent && resetForm.get('email').hasError('required')"
                  >
                    {{ 'global.validators.required.error' | translate }}
                  </div>

                  <div
                    class="invalid-feedback"
                    *ngIf="
                      sent && resetForm.get('email').hasError('invalidEmail')
                    "
                  >
                    {{ 'Please enter a valid e-mail' | translate }}
                  </div>
                </div>
              </div>

              <div class="form-group row mt-5 mb-0">
                <div class="col-sm text-center">
                  <button
                    type="submit"
                    class="btn btn-lg btn-outline-primary btn-wide px-4"
                    [disabled]="loading"
                  >
                    <span>{{ 'Reset password' | translate }}</span>
                    <i *ngIf="loading" class="fa fa-spinner fa-spin ml-2"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div class="card-body" *ngIf="linkSent">
            <h3 class="card-title">{{ 'Reset requested' | translate }}</h3>
            <hr class="mb-4 mb-sm-5" />

            <p>
              {{
                'We have sent you an email with instructions to reset your password.'
                  | translate
              }}
            </p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="changePasswordForm && hasToken">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h1 class="card-title">{{ 'Reset password' | translate }}</h1>
              </div>
              <div class="col-auto ml-auto">
                <app-language-dropdown></app-language-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <hr class="mb-4 mb-sm-5 mt-1" />
              </div>
            </div>

            <form
              (ngSubmit)="onChangePassword()"
              [formGroup]="changePasswordForm"
            >
              <div class="form-group row">
                <label class="col-form-label col-sm-4" for="password">{{
                  'New password' | translate
                }}</label>
                <div class="col-sm">
                  <input
                    class="form-control"
                    name="password"
                    type="password"
                    novalidate="novalidate"
                    id="password"
                    autofocus=""
                    formControlName="newPassword"
                    [class.is-invalid]="
                      sent &&
                      (changePasswordForm
                        .get('newPassword')
                        .hasError('required') ||
                        changePasswordForm
                          .get('newPassword')
                          .hasError('minlength'))
                    "
                  />

                  <div
                    class="invalid-feedback"
                    *ngIf="
                      sent &&
                      changePasswordForm.get('newPassword').hasError('required')
                    "
                  >
                    {{ 'global.validators.required.error' | translate }}
                  </div>

                  <div
                    class="invalid-feedback"
                    *ngIf="
                      sent &&
                      changePasswordForm
                        .get('newPassword')
                        .hasError('minlength')
                    "
                  >
                    {{
                      'Password must be atleast 8 characters long.' | translate
                    }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-form-label col-sm-4" for="newPassword2">{{
                  'Confirm new password' | translate
                }}</label>
                <div class="col-sm">
                  <input
                    class="form-control"
                    name="newPassword2"
                    type="password"
                    novalidate="novalidate"
                    id="newPassword2"
                    autofocus=""
                    formControlName="newPassword2"
                    [class.is-invalid]="
                      sent &&
                      changePasswordForm.errors?.passwordsMatch === false &&
                      changePasswordForm.get('newPassword').value !== ''
                    "
                  />

                  <div
                    class="invalid-feedback"
                    *ngIf="
                      sent &&
                      changePasswordForm.errors?.passwordsMatch === false &&
                      changePasswordForm.get('newPassword').value !== ''
                    "
                  >
                    {{ "Passwords don't match" | translate }}
                  </div>
                </div>
              </div>

              <div class="form-group row mt-5">
                <div class="col-sm text-center">
                  <button
                    type="submit"
                    class="btn btn-lg btn-outline-primary btn-wide px-4"
                    [disabled]="loading"
                  >
                    <span>{{ 'Reset password' | translate }}</span>
                    <i *ngIf="loading" class="fa fa-spinner fa-spin ml-2"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
